import { createSlice } from "@reduxjs/toolkit";

const initState = {
  evaluations: [],
};

export const evaluationsSlice = createSlice({
  name: "evaluations",
  initialState: initState,
  reducers: {
    setEvaluationsReducer: (state, action) => {
      let tempObj = { ...state, ...action.payload };
      return tempObj;
    },
    resetEvaluationsReducer: () => initState,
  },
});

export const { setEvaluationsReducer, resetEvaluationsReducer } =
  evaluationsSlice.actions;

export default evaluationsSlice.reducer;
